import { render, staticRenderFns } from "./OrderAudio.vue?vue&type=template&id=4f252262&scoped=true"
import script from "./OrderAudio.vue?vue&type=script&lang=js"
export * from "./OrderAudio.vue?vue&type=script&lang=js"
import style0 from "./OrderAudio.vue?vue&type=style&index=0&id=4f252262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f252262",
  null
  
)

export default component.exports